import TopRated from '@/assets/icons/top-rated.svg?react';
import AppleStoreLinkIcon from '@/shared/components/AppleStoreLinkIcon';
import GooglePlayLinkIcon from '@/shared/components/GooglePlayLinkIcon';

const RatedSection = () => {
  return (
    <section className="flex flex-wrap items-center justify-center gap-12 bg-light-primary px-4 py-14 sm:py-20">
      <TopRated className="w-64" />
      <div className="flex flex-col gap-8 sm:max-w-min">
        <h3 className="w-full text-center font-semibold text-3xl sm:text-start">
          Designed to help you to be found around the world
        </h3>
        <div className="w- flex w-full flex-col items-center gap-6 sm:flex-row sm:gap-8">
          <GooglePlayLinkIcon
            iconProps={{
              className:
                'sm:h-[80px] sm:w-[240px] cursor-pointer h-[66px] w-[200px]',
            }}
          />
          <AppleStoreLinkIcon
            iconProps={{
              className:
                'sm:h-[80px] sm:w-[240px] cursor-pointer h-[66px] w-[200px]',
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default RatedSection;
